import React, { useRef } from 'react';

import type { Moment } from 'moment';

import type { FilterValues, SetValueProps } from '@src/components/FilterDropDown/FilterDropDown.interfaces';
import SecondaryPanel from '@src/components/SecondaryPanel/SecondaryPanel';
import ApplyReportFiltersButton from '@src/packages/dashboard/components/ApplyReportFiltersButton';

import type { TasksChartFilters } from '../../tasksFilterConfig';
import type { SelectedSchedulesState } from '../../types';
import TasksDashboardFilters from '../TasksDashboardFilters';

interface TasksFilterPanelProps {
  title: string;
  filters: FilterValues;
  initialFilters: FilterValues;
  chartFilters: TasksChartFilters;
  orgId: string;
  divisionIds: string[];
  disabledDate: (date: Moment) => boolean;
  onFiltersChange: (props: SetValueProps | SetValueProps[]) => void;
  onTemplatesChange: React.Dispatch<React.SetStateAction<SelectedSchedulesState>>;
  onApplyFilters: () => void;
  hasPendingFilters: boolean;
  isApplyingFilters: boolean;
}

/** Side panel hosting the report filters. Initial values are fixed at mount, as the panel expects. */
const TasksFilterPanel: React.FC<TasksFilterPanelProps> = ({
  title,
  filters,
  initialFilters,
  chartFilters,
  orgId,
  divisionIds,
  disabledDate,
  onFiltersChange,
  onTemplatesChange,
  onApplyFilters,
  hasPendingFilters,
  isApplyingFilters,
}) => {
  const initialFiltersRef = useRef(initialFilters);

  return (
    <SecondaryPanel.Panel title={title} initialValues={initialFiltersRef.current}>
      <TasksDashboardFilters
        handleFilters={onFiltersChange}
        filters={filters}
        chartFilters={chartFilters}
        orgId={orgId}
        divisionIds={divisionIds}
        disabledDate={disabledDate}
        onTemplatesChange={onTemplatesChange}
      />
      <ApplyReportFiltersButton
        onClick={onApplyFilters}
        disabled={!hasPendingFilters || isApplyingFilters}
        loading={isApplyingFilters}
      />
    </SecondaryPanel.Panel>
  );
};

export default React.memo(TasksFilterPanel);
